import { defineComponent as _defineComponent } from 'vue'
import { emptyPlantForm } from "@/models/plant/plant.form"
import { ref } from "vue"
import PlantForm from "@/components/plant/PlantForm.vue"


const __default__ = {
  name: "NewPlant"
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose }) {
  expose();

const plant = ref({
  ...emptyPlantForm
})

const __returned__ = { plant, PlantForm }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})